export type FormStatePort = {
  resetFields: () => void;
  setFieldsValue: (values?: Record<string, unknown>) => void;
};

export type FormOpenStateOptions = {
  resetFields?: boolean;
  initValues?: Record<string, unknown>;
};

export const prepareFormForOpen = (form: FormStatePort, options: FormOpenStateOptions = {}) => {
  if (options.resetFields) form.resetFields();
  form.setFieldsValue(options.initValues);
};
